"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvrReportsService = void 0;
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("./base.service");
var api_constants_1 = require("../constants/api.constants");
var serializers_1 = require("./serializers");
var AvrReportsService = /** @class */ (function (_super) {
    __extends(AvrReportsService, _super);
    function AvrReportsService(options, assessmentsStandardReportOfItemClient, summaryReportForSchoolClient, summaryReportForClassClient, averageSummaryAvrSerializer, adminAssessmentListSerializer, averageScoreSchoolAvrSerializer, averageScoreClassAvrSerializer, averageScoreClassAvrByItemSerializer, assessmentsAverageScoreByItemSerializer, studentsScoreDistributionPerformanceSerializer, studentsScoreDistributionPerformanceClassSerializer) {
        var _this = _super.call(this, options) || this;
        _this.assessmentsStandardReportOfItemClient = assessmentsStandardReportOfItemClient;
        _this.summaryReportForSchoolClient = summaryReportForSchoolClient;
        _this.summaryReportForClassClient = summaryReportForClassClient;
        _this.averageScoreSchoolAvrSerializer = averageScoreSchoolAvrSerializer;
        _this.averageScoreClassAvrSerializer = averageScoreClassAvrSerializer;
        _this.averageScoreClassAvrByItemSerializer = averageScoreClassAvrByItemSerializer;
        _this.adminAssessmentListSerializer = adminAssessmentListSerializer;
        _this.averageSummaryAvrSerializer = averageSummaryAvrSerializer;
        _this.assessmentsAverageScoreByItemSerializer = assessmentsAverageScoreByItemSerializer;
        _this.studentsScoreDistributionPerformanceSerializer =
            studentsScoreDistributionPerformanceSerializer;
        _this.studentsScoreDistributionPerformanceClassSerializer =
            studentsScoreDistributionPerformanceClassSerializer;
        return _this;
    }
    AvrReportsService.newInstance = function (options) {
        return new AvrReportsService(options, insync_assess_sdk_1.StandardsReportClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), insync_assess_sdk_1.SummaryReportForSchoolClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), insync_assess_sdk_1.SummaryReportForClassClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), new serializers_1.AverageSummaryAvrSerializer(), new serializers_1.AdminAssessmentListSerializer(), new serializers_1.AverageScoreSchoolAvrSerializer(), new serializers_1.AverageScoreClassAvrSerializer(), new serializers_1.AverageScoreClassAvrByItemSerializer(), new serializers_1.AssessmentsAverageScoreByItemSerializer(), new serializers_1.StudentsScoreDistributionPerformanceSerializer(), new serializers_1.StudentsScoreDistributionPerformanceClassSerializer());
    };
    /**
     * @param filters
     * @param {boolean} useV2 - useV2 API is used temporarily as the old API was not optimised but the outcome will be same for both API calls
     * @returns
     */
    AvrReportsService.prototype.findAdminAssessmentList = function (filters_1, enrollmentPeriodId_1) {
        return __awaiter(this, arguments, void 0, function (filters, enrollmentPeriodId, useV2) {
            var assessmentList, _a;
            var _this = this;
            if (useV2 === void 0) { useV2 = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!useV2) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.summaryReportForSchoolClient.assessmentsListBySchoolV2(filters, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.summaryReportForSchoolClient.assessmentsListBySchool(filters, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        assessmentList = _a;
                        return [2 /*return*/, (assessmentList || []).map(function (assessment) {
                                return _this.adminAssessmentListSerializer.serialize(assessment);
                            })];
                }
            });
        });
    };
    /**
     * School Report avg count
     * @param filters
     * @returns
     */
    AvrReportsService.prototype.findAvgSummaryAvr = function (filters_1, enrollmentPeriodId_1) {
        return __awaiter(this, arguments, void 0, function (filters, enrollmentPeriodId, useV2) {
            var scoreSummary, _a;
            if (useV2 === void 0) { useV2 = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!useV2) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.summaryReportForSchoolClient.assessmentsScoreSummaryV2(filters, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.summaryReportForSchoolClient.assessmentsScoreSummary(filters, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        scoreSummary = _a;
                        return [2 /*return*/, this.averageSummaryAvrSerializer.serialize(scoreSummary)];
                }
            });
        });
    };
    /**
     * School report Avg score bar graph
     * @param filters
     * @returns
     */
    AvrReportsService.prototype.findAverageScoreSchoolAvr = function (filters_1, enrollmentPeriodId_1) {
        return __awaiter(this, arguments, void 0, function (filters, enrollmentPeriodId, useV2) {
            var assessmentAverageScores, _a;
            var _this = this;
            if (useV2 === void 0) { useV2 = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!useV2) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.summaryReportForSchoolClient.assessmentsAverageScoreBySchoolV2(filters, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.summaryReportForSchoolClient.assessmentsAverageScoreBySchool(filters, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        assessmentAverageScores = _a;
                        return [2 /*return*/, assessmentAverageScores.map(function (assessmentAverageScore) {
                                return _this.averageScoreSchoolAvrSerializer.serialize(assessmentAverageScore);
                            })];
                }
            });
        });
    };
    /**
     * School report Avg score Raw Points
     * @param filters
     * @returns
     */
    AvrReportsService.prototype.findScoreByItemAvr = function (filters_1, enrollmentPeriodId_1) {
        return __awaiter(this, arguments, void 0, function (filters, enrollmentPeriodId, useV2) {
            var defaultHeaders, assessmentsAverageScoreByItems, _a;
            if (useV2 === void 0) { useV2 = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        defaultHeaders = this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId });
                        if (!useV2) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.summaryReportForSchoolClient.assessmentsAverageScoreByItemV2(filters, defaultHeaders)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.summaryReportForSchoolClient.assessmentsAverageScoreByItem(filters, defaultHeaders)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        assessmentsAverageScoreByItems = _a;
                        return [2 /*return*/, assessmentsAverageScoreByItems.map(this.assessmentsAverageScoreByItemSerializer.serialize)];
                }
            });
        });
    };
    /**
     * School report Avg score Distribution Data
     * @param filters
     * @returns
     */
    AvrReportsService.prototype.findStudentDistributionAvr = function (filters_1, enrollmentPeriodId_1) {
        return __awaiter(this, arguments, void 0, function (filters, enrollmentPeriodId, useV2) {
            var studentsScoreDistributionPerformances, _a;
            var _this = this;
            if (useV2 === void 0) { useV2 = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!useV2) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.summaryReportForSchoolClient.studentsDistributionBySchoolV2(filters, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.summaryReportForSchoolClient.studentsDistributionBySchool(filters, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        studentsScoreDistributionPerformances = _a;
                        return [2 /*return*/, studentsScoreDistributionPerformances.map(function (studentsScoreDistributionPerformance) {
                                return _this.studentsScoreDistributionPerformanceSerializer.serialize(studentsScoreDistributionPerformance);
                            })];
                }
            });
        });
    };
    /**
     * Class report Avg score bar graph
     * @param filters
     * @returns
     */
    AvrReportsService.prototype.findAverageScoreClassAvr = function (filters_1, enrollmentPeriodId_1) {
        return __awaiter(this, arguments, void 0, function (filters, enrollmentPeriodId, useV2) {
            var defaultHeaders, assessmentAverageClassScores, _a;
            if (useV2 === void 0) { useV2 = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        defaultHeaders = this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId });
                        if (!useV2) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.summaryReportForClassClient.assessmentsScoreAverageForClassV2(filters, defaultHeaders)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.summaryReportForClassClient.assessmentsScoreAverageForClass(filters, defaultHeaders)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        assessmentAverageClassScores = _a;
                        return [2 /*return*/, assessmentAverageClassScores.map(this.averageScoreClassAvrSerializer.serialize)];
                }
            });
        });
    };
    /**
     * Class reports Avg score Raw Points
     * @param filters
     * @returns
     */
    AvrReportsService.prototype.findAverageScoreByItemsClassAvr = function (filters_1, enrollmentPeriodId_1) {
        return __awaiter(this, arguments, void 0, function (filters, enrollmentPeriodId, useV2) {
            var defaultHeaders, assessmentAverageClassScoresByItem, _a;
            if (useV2 === void 0) { useV2 = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        defaultHeaders = this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId });
                        if (!useV2) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.summaryReportForClassClient.assessmentsAverageScoreOfClassItemWiseV2(filters, defaultHeaders)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.summaryReportForClassClient.assessmentsAverageScoreOfClassItemWise(filters, defaultHeaders)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        assessmentAverageClassScoresByItem = _a;
                        return [2 /*return*/, assessmentAverageClassScoresByItem.map(this.averageScoreClassAvrByItemSerializer.serialize)];
                }
            });
        });
    };
    /**
     * Class report Avg score Distribution Data
     * @param filters
     * @returns
     */
    AvrReportsService.prototype.findStudentDistributionClassAvr = function (filters_1, enrollmentPeriodId_1) {
        return __awaiter(this, arguments, void 0, function (filters, enrollmentPeriodId, useV2) {
            var defaultHeaders, studentsScoreDistributionClassPerformances, _a;
            if (useV2 === void 0) { useV2 = true; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        defaultHeaders = this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId });
                        if (!useV2) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.summaryReportForClassClient.studentsDistributionByClassV2(filters, defaultHeaders)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.summaryReportForClassClient.studentsDistributionByClass(filters, defaultHeaders)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        studentsScoreDistributionClassPerformances = _a;
                        return [2 /*return*/, studentsScoreDistributionClassPerformances.map(this.studentsScoreDistributionPerformanceClassSerializer.serialize)];
                }
            });
        });
    };
    AvrReportsService.prototype.getSummaryReportItemStandards = function (curriculum, assessmentTemplateId, enrollmentPeriodId, useV2) {
        if (useV2 === void 0) { useV2 = true; }
        return useV2
            ? this.assessmentsStandardReportOfItemClient.assessmentsStandardReportOfItemV2({ curriculum: curriculum, assessmentTemplateId: assessmentTemplateId }, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }))
            : this.assessmentsStandardReportOfItemClient.assessmentsStandardReportOfItem({ curriculum: curriculum, assessmentTemplateId: assessmentTemplateId }, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }));
    };
    /**
     * Get list of school for given assessment template id
     * @param {string} assessmentTemplateId assessment template id
     * @param {string} enrollmentPeriodId school year id
     * @returns {Promise<School[]>} school list
     */
    AvrReportsService.prototype.getAssessmentsSchoolListByAssessmentTemplate = function (assessmentTemplateId, enrollmentPeriodId) {
        return this.summaryReportForSchoolClient.assessmentsSchoolListByAssessmentTemplate(assessmentTemplateId, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }));
    };
    /**
     * Get classes for the given schools
     * @param assessmentTemplateId assessment template id
     * @param schoolIds array of schools id
     * @param enrollmentPeriodId school year id
     * @returns {Promise<IClassOfSchool[]>} Classes for the given schools
     */
    AvrReportsService.prototype.getClassesOfSchools = function (assessmentTemplateId, schoolIds, enrollmentPeriodId) {
        return this.summaryReportForClassClient.assessmentsClassList({ assessmentTemplateId: assessmentTemplateId, schoolIds: schoolIds }, this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId }));
    };
    return AvrReportsService;
}(base_service_1.BaseService));
exports.AvrReportsService = AvrReportsService;
